import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import View from '../View';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Row',
  showEmpty: true,
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'flex',
          marginRight: px(-8),
          marginLeft: px(-8),
        },
      },
      tiny: {
        noPseudo: {
          flexDirection: 'column',
        },
      },
    },
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
